<!--
  PLACEHOLDER — Income Estimate (demo)

  Horizon segmented control + "Configure price assumptions" link. The
  segmented control is fully functional (drives chart + table). The
  configure link opens SpotConfigModal which is itself visual-only.
-->
<template>
  <div
    class="income-toolbar d-flex flex-wrap align-items-center gap-3 px-4 py-2 bg-body-tertiary"
  >
    <span class="eyebrow-label">Horizon</span>
    <div class="ds-segctrl">
      <button
        :class="{ 'is-on': horizon === 'current-year' }"
        @click="update('current-year')"
      >
        Rest of 2026
      </button>
      <button
        :class="{ 'is-on': horizon === 'next-12' }"
        @click="update('next-12')"
      >
        Next 12 mo
      </button>
      <button
        :class="{ 'is-on': horizon === 'two-year' }"
        @click="update('two-year')"
      >
        Next 2 years
      </button>
    </div>
    <button
      class="income-toolbar-link ms-auto btn btn-sm d-inline-flex align-items-center gap-2"
      title="You're using default price assumptions — adjust to match your actual contracts and market view"
      @click="$emit('configure-spot')"
    >
      <span class="gear-dot" />
      Configure price assumptions
      <span
        class="defaults-badge text-uppercase fw-semibold ps-2 ms-1 border-start"
      >
        Defaults
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
import type { HorizonValue } from "./incomeEstimateDemoData";

const horizon = defineModel<HorizonValue>("horizon", { required: true });

defineEmits<{
  "configure-spot": [];
}>();

const update = (value: HorizonValue) => {
  horizon.value = value;
};
</script>

<style scoped lang="scss">
/* NOTE: the ochre-bordered "Configure price assumptions" button is a
   design-specific primitive — Bootstrap btn-outline-* uses the theme accent
   and a different padding/typography scale, so it stays local. The segmented
   control comes from the shared .ds-segctrl in assets/utilities.scss. */
.income-toolbar-link {
  background: var(--phoenix-white);
  border: 1px solid var(--phoenix-orange-300);
  color: var(--phoenix-emphasis-color);
  font-size: 12px;
  font-weight: 500;

  &:hover {
    border-color: var(--phoenix-warning);
    background: rgba(var(--phoenix-warning-rgb), 0.04);
  }

  .gear-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--phoenix-warning);
  }
}

.defaults-badge {
  font-size: 10px;
  color: var(--phoenix-warning-text-emphasis);
  letter-spacing: 0.06em;
}
</style>
